import { com } from '@eidu/web'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import createPermissionPolicy from './api/entity/permissionPolicy/createPermissionPolicy'
import updatePermissionPolicy from './api/entity/permissionPolicy/updatePermissionPolicy'
import deletePermissionPolicy from './api/entity/permissionPolicy/deletePermissionPolicy'
import { PermissionPolicyDTO } from '../domain/permission/PermissionPolicyDTO'
import { auditLogKeys, permissionPolicyKeys } from './queryKeys'
import PermissionPolicyId = com.eidu.sharedlib.entity.permission.PermissionPolicyId
import Permission = com.eidu.sharedlib.entity.permission.Permission

type CreateParams = {
  name: string
  permissions: readonly Permission[]
}

export const useCreatePermissionPolicy = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ name, permissions }: CreateParams): Promise<PermissionPolicyDTO> =>
      createPermissionPolicy({ name, permissions }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permissionPolicyKeys.all })
      queryClient.invalidateQueries({ queryKey: auditLogKeys.all })
    },
  })
}

type ModifyParams = {
  id: PermissionPolicyId
  name: string
  permissions: readonly Permission[]
}

export const useModifyPermissionPolicy = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ id, name, permissions }: ModifyParams): Promise<PermissionPolicyDTO> =>
      updatePermissionPolicy({ id, name, permissions }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permissionPolicyKeys.all })
      queryClient.invalidateQueries({ queryKey: auditLogKeys.all })
    },
  })
}

export const useDeletePermissionPolicy = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (id: PermissionPolicyId): Promise<void> => deletePermissionPolicy({ id }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: permissionPolicyKeys.all })
      queryClient.invalidateQueries({ queryKey: auditLogKeys.all })
    },
  })
}
